import { Currency } from "src/app/services/response-models/currency.model";

export class SetCurrencies {
    static readonly type = "[APP] Set Currencies";
    constructor(public payload: Currency[]) {}
}
